import { useForm } from "react-hook-form";
import Input from "../../../../components/input/Input";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import "./DnsSettings.css";
import { api } from "../../../../utils/api";
import { useQuery } from "react-query";
import { getNameServers } from "../../../../services/LandingPages/getNameServers";
import { useNavigate } from "react-router-dom";

const DnsSettings = ({ enterprise_id, domain, onDomainChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [dominio, setDominio] = useState("");
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      domain: "",
      subdomain: "",
    },
  });

  const {
    data: nsData,
    isLoading: nsLoading,
    error: nsError,
  } = useQuery(
    ["nameservers", enterprise_id],
    () => getNameServers(enterprise_id),
    {
      enabled: !!enterprise_id,
    }
  );
  console.log("nsData", nsData);

  useEffect(() => {
    if (nsData) {
      const subdomain = nsData?.host?.Name?.replace(/\.$/, "") || "";
      const domain = nsData?.landingPageSignature?.domain || "";

      reset((prev) => ({
        ...prev,
        subdomain,
        domain,
      }));

      onDomainChange && onDomainChange({ domain, subdomain });
    }
  }, [nsData, reset]);

  const onSubmit = async (data) => {
    const payload = {
      enterprise_id: parseInt(enterprise_id),
      ...(data.domain ? { domain: String(data.domain) } : {}), // só adiciona se tiver valor
    };

    const toastId = toast.loading("Salvando configurações...");

    try {
      await api.post("/landingPage/configDomain", payload);

      toast.update(toastId, {
        render: "Configurações salvas com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
        closeOnClick: true,
      });

      reset(data);
      setIsEditing(false);
    } catch (err) {
      toast.update(toastId, {
        render: "Erro ao salvar configurações.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
  };

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copiado para a área de transferência!");
    } catch (err) {
      toast.error("Erro ao copiar.");
    }
  };

  return (
    <div
      className="row d-flex flex-column"
      style={{ fontFamily: "Axiforma, sans-serif" }}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column">
        <div className="col-md-6 col-12">
          <Input
            control={control}
            name="domain"
            label="Domínio"
            errors={errors}
            disabled={!isEditing}
            className={!isEditing ? "no-border" : ""}
          />
        </div>
        <div className="col-md-6 col-12">
          <Input
            control={control}
            name="subdomain"
            label="Subdomínio"
            errors={errors}
            disabled
            className="no-border"
          />
        </div>

        {isEditing && (
          <div className="col-md-3 col-12 mt-4 d-flex align-items-end">
            <Button
              label="Salvar"
              icon="pi pi-check"
              iconPos="right"
              type="submit"
              className="p-button-rounded w-100"
            />
          </div>
        )}
      </form>

      {!isEditing && (
        <div className="col-md-3 col-12 mt-4 d-flex align-items-end">
          <Button
            label="Editar"
            icon="pi pi-pencil"
            className="p-button-secondary w-100"
            type="button"
            onClick={() => setIsEditing(true)}
          />
        </div>
      )}

      {/* DNS Section */}
      <div className="mt-5 w-auto">
        <h4>Informações de DNS</h4>
        <p className="text-muted w-auto mb-3 fs-6 bg-warning px-3 py-2 rounded">
          Para configurar o DNS do seu domínio, adicione os seguintes registros
          no painel de controle do seu provedor de domínio:
        </p>

        {nsLoading && <p>Carregando servidores DNS...</p>}
        {nsError && <p className="text-danger">Erro ao buscar DNS</p>}

        {nsData?.ns?.map((ns, index) => (
          <div key={ns} className="d-flex align-items-center gap-1 mb-2">
            <h5 className="m-0 w-auto">{`NS${index + 1}:`}</h5>
            <div className="px-3 py-2 d-flex align-items-center justify-content-between">
              <p className="m-0 me-3">{ns}</p>
              <Button
                icon="pi pi-copy"
                className="p-button-text p-button-sm"
                tooltip="Copiar"
                type="button"
                onClick={() => handleCopy(ns)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DnsSettings;
